import React, { memo, useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ScrollView } from 'react-native'
import { useNavigation } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { StyleService, useStyleSheet } from '@src/style/service'
import { Calendar } from '@models/app.types'
import { AppStackParamList } from '@navigation/types'
import { CalendarTabs } from '@src/screens/Insights/components/CalendarBar/CalendarTabs'
import { insightsCalendarSelector } from '@screens/Insights/models/insights.selectors'
import { CalendarIconWithDate } from '@src/components/CalendarTabs/CalendarIconWithDate'
import { DateRange } from '@src/models/helper'
import { CALENDAR_TABS } from '../../constants'

interface CalendarBarProps {
  fetchStats: (params: DateRange) => void
}

export const CalendarBar = memo((props: CalendarBarProps) => {
  const { fetchStats } = props
  const dispatch = useDispatch()
  const styles = useStyleSheet(themedStyle)
  const navigation = useNavigation<StackNavigationProp<AppStackParamList>>()

  const calendar = useSelector(insightsCalendarSelector)

  const handleCalendarChange = useCallback(
    (newCalendar: Calendar) => {
      dispatch({
        type: 'insights/updateCalendarState',
        payload: newCalendar,
      })
    },
    [dispatch],
  )

  useEffect(() => {
    fetchStats({
      startDate: calendar.startDate,
      endDate: calendar.endDate,
    })
  }, [calendar.startDate, calendar.endDate, fetchStats])

  const onCalendarIconPress = () => {
    navigation.navigate('ChangeDateRange', { type: 'insights' })
  }

  return (
    <ScrollView
      contentContainerStyle={styles.scrollView}
      horizontal
      showsHorizontalScrollIndicator={false}
      bounces={false}
    >
      <CalendarIconWithDate
        calendar={calendar}
        isSelectedProp={!Object.keys(CALENDAR_TABS).includes(calendar.rangeDays.toString())}
        onPress={onCalendarIconPress}
      />
      <CalendarTabs calendar={calendar} onChange={handleCalendarChange} />
    </ScrollView>
  )
})

const themedStyle = StyleService.create({
  scrollView: {
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 12,
    paddingVertical: 4,
    gap: 8,
  },
})
